<template>
  <div v-if="!isBlank && !isRowLoading" class="main-container">
    <div :id="elementID" ref="storyTitle" v-bind:class="{'story-title':true, 'hasNoBottomMargin':hasNoBottomMargin}" v-line-clamp="titleLines">
      {{ title }}
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import breakpoints from '@/libs/breakpoints'
import lineClamp from 'vue-line-clamp'
Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})
export default {
  props: ['isRowLoading', 'isBlank', 'title', 'elementID', 'customLineClamp', 'hasNoBottomMargin'],
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    },
    titleLines: function () {
      return this.customLineClamp ? this.customLineClamp : 2
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .story-title {
    overflow: visible;
    word-break: break-word !important;
    font-family: $primary-font;
    color: $black;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.45;
    margin: 0.5rem 0.75rem;
    display: flex;
    justify-content: center;
    align-items: left;
    color: var(--background-third);
    @include mobile {
      font-size: 0.9rem;
      font-weight: 500;
      line-height: 1.45;
      margin: 0.5rem;
    }
  }
  .hasNoBottomMargin {
    margin-bottom: 0rem;
    min-height: 20px !important;
  }
  .main-container {
    height: auto;
  }
</style>
